import { render, staticRenderFns } from "./StatsTab.vue?vue&type=template&id=677b3cf3"
import script from "./StatsTab.vue?vue&type=script&lang=js"
export * from "./StatsTab.vue?vue&type=script&lang=js"
import style0 from "./StatsTab.vue?vue&type=style&index=0&id=677b3cf3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports